
define('ldsh!modules/editor/templates/navigation_tab', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<a title="TAB ' +
((__t = ( id )) == null ? '' : __t) +
'" class="js-tab-switch" data-tab-key="#' +
((__t = ( role )) == null ? '' : __t) +
'' +
((__t = ( id )) == null ? '' : __t) +
'"\n  href="#"><span data-i18n="' +
((__t = ( translationKey )) == null ? '' : __t) +
'"></span> <em class="ed-tab-step-number">' +
((__t = ( id )) == null ? '' : __t) +
'</em></a>\n';
 if (isRemovable) { ;
__p += '\n<i\n  class="ri-close-line ed-action ed-delete-item js-delete-step f22"\n  aria-hidden="true"\n  data-i18n="[title]landingPage.removePage"\n></i>\n';
};
__p += '\n';

}
return __p
};});

